module.exports = __webpack_public_path__ + "static/img/klp1160-663-37084rd.25ac4b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/klp1160-663-37084rd.jpg
// module id = 8pEI
// module chunks = 0